<template>
  <modal name="add-cpv-modal"
         @before-close="resetComponent"
         @before-open="setProps"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Ավելացնել գնման առարկա</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('add-cpv-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="px-4 py-5" style="overflow-x: auto; height: 90%">
      <div class="row">
        <div class="col-12">
          <cpv-selector id="cpv-selector" :selectedCpvs.sync="selectedCpvs" />
        </div>
      </div>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button @click="addRows" type="button" class="btn btn-sm btn-primary"> 
        Ավելացնել
      </button>
    </div>
  </modal>
</template>

<script>
  import CpvSelector from '@/components/dashboard/cpv/CpvSelector'
  // import CpvSearch from '@/components/dashboard/cpv/CpvSearch'
  import purchaseTypes from '@/mixins/purchaseTypes'

  export default {
    name: 'AddCpvModal',
    mixins: [purchaseTypes],
    components: { CpvSelector },
    computed: {
      // combinedCpvs() {
      //   // eslint-disable-next-line no-undef
      //   return _.unionWith(this.selectedCpvs, this.searchedCpvs, _.isEqual)
      // },
      units() {
        return this.$store.getters['settings/units']
      },
      classifiers() {
        return this.$store.getters['settings/classifiers']
      },
    },
    data() {
      return this.getComponentInitialData()
    },
    methods: {
      getComponentInitialData() {
        return {
          selectedCpvs: [],
          cpvSpecs: [],
          handleAddRows: undefined,
        }
      },
      resetComponent() {
        Object.assign(this.$data, this.getComponentInitialData())
      },
      setProps({ params }) {
        this.handleAddRows = params
      },
      addRows() {
        this.handleAddRows(this.selectedCpvs);
        this.$modal.hide('add-cpv-modal');
      },
      consoleLog(msg) {
        console.log(typeof msg, 'sdlkjflsk')
      },
    },
  }
</script>

<style scoped>
  .scroll-button {
    z-index: 9999;
    width: 30px;
    position: absolute;
    height: 50%;
    top: 30%;
    transform: translate(0, -15%);
  }

  .scroll-button.right {
    right: 0;
    border-bottom-left-radius: 100px;
    border-top-left-radius: 100px;
    background-image: linear-gradient(to left, #cdd1fb, #fff);
  }

  .scroll-button.left {
    left: 0;
    border-bottom-right-radius: 100px;
    border-top-right-radius: 100px;
    background-image: linear-gradient(to right, #cdd1fb, #fff)
  }

  .tableFixHead {
    overflow: auto;
    height: calc(100% - 1rem);
  }

  .tableFixHead thead th {
    position: sticky;
    top: 0;
    z-index: 99
  }

  /* Just common table stuff. Really. */
  table {
    border-collapse: collapse;
    width: 100%;
  }

  th, td {
    padding: 8px 16px;
  }

  th {
    background: #fff;
  }

  select.form-control.custom-select_opt {
    width: 140px;
  }

  select.form-control.form-control-opt {
    width: 200px;
  }

  tbody::before {
    content: '';
    display: block;
    height: 15px;

  }
</style>
